import { Box, Grid, IconButton, Typography } from '@mui/material';
import AngleRightIcon from 'common/customIcons/angle_right';
import CommonLayout from 'layouts/DashboardLayout';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CatalogProducts from './CatalogProducts';
import { getPermissionsByMode } from 'utilities/common';
import { hasSectionPermission } from 'utilities/common';
import { getData } from 'utilities/common';

export default function MasterCatalog({ mode }) {
  const navigate = useNavigate();
  const [selectedCatalogProducts, setSelectedCatalogProducts] = useState({});

  const catalogProductSelectionHandler = (products) => {
    let brandWiseProducts = products?.reduce((prev, curr) => {
      return { ...prev, [curr.brandSlug]: [...prev[curr?.brandSlug] || [], curr] };
    }, {});
    setSelectedCatalogProducts({ ...brandWiseProducts });
  };

    let localUser = getData('login-user-info')
    if (localUser) {
      localUser = JSON.parse(localUser)
    }
  
    const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
    const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);
  
    const canCreate = hasSectionPermission(permissionsForMode, "Product", "Create");
    const canEdit = hasSectionPermission(permissionsForMode, "Product", "Edit/Update");
    const canView = hasSectionPermission(permissionsForMode, "Product", "View Only");
    const canDelete = hasSectionPermission(permissionsForMode, "Product", "Delete");
  return (
    <CommonLayout>
      {
        canView &&
      <Box padding={3}>
        <Box display="flex" alignItems="center" color='text.main' lineHeight={1} mb={2}>
          <IconButton onClick={() => navigate(-1)}>
            <AngleRightIcon fontSize="14px" />
          </IconButton>
          <Typography variant='h6' fontWeight="semibold" ml={.75}>Products</Typography>
        </Box>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={12}>
            <CatalogProducts
              mode={mode}
              catalogProductSelectionHandler={catalogProductSelectionHandler}
              selectedCatalogProducts={selectedCatalogProducts}
              setSelectedCatalogProducts={setSelectedCatalogProducts}
            />
          </Grid>
        </Grid>
      </Box>
      }
    </CommonLayout>
  );
}
